.filterText {
	font-weight: var(--ds-font-weight-bold, bold);
}
